import script from "./calendar-list.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar-list.vue?vue&type=script&setup=true&lang=js"

import "./calendar-list.vue?vue&type=style&index=0&id=aa52bbf6&lang=css"

const __exports__ = script;

export default __exports__